<section class="search-holder">
    <div class="container p-4">
        <div class="row">
            <div class="col-sm-12">
                <h2 class="m-0">Property Management</h2>
            </div>
        </div>
    </div>
</section>
<div class="container mt-5 mb-5">
    <div class="row">
        <div class="col-sm-12">
            <p>Nepal Property Services (NEPROSE) offers commercial and private clients in Birtamod, Jhapa a full suite of integrated multidisciplinary contracted services to ensure seamless operation of their new or existing facilities. Backed by the resources of Nepal Property Services and its partner(s) currently we provide our services within Birtamode Municipality only.</p>

            <p>Nepal Property Services can capably manage anything from buildings operations to asset management through a single point of contact. This specialized NEPROSE ONE-touch approach translates into ease for our clients. It also comes with the trust and assurance of knowing all contracted services have been vetted for NEPROSE-approved best practices, efficiencies and cost savings.</p>

            <ul>
                <li>Electricity, water, gas and tap maintenance services</li>
                <li>Necessary and transportation services for relocating your home, office, room, shop</li>
                <li>Manage and maintain house, office, land</li>
                <li>To manage private or government buildings, hospitals, parks etc</li>
            </ul>

            <p>Most importantly, all work – whether self-performed or subcontracted – is subject to NEPROSE’s number one core value of Safety First.</p>
        </div>
    </div>
</div>